import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from '../Common/Grid';
import OrderSummary from './OrderSummary';
import OrderTotalSummary from './OrderTotalSummary';
import OrderDetailsCTAGroup from './OrderDetailsCTAGroup';
import OrderItemsContainer from './OrderItemsContainer';
import WssPaymentAuthorizationSection from './WssPaymentAuthorizationSection';
import WssOrderDetailsSection from './WssOrderDetailsSection';
import { orderDetailsDataProps, orderDetailsDataDefaultProps } from './props';

export default function OrderDetailsContent({ queryData, onPaymentError, onPaymentSuccess }) {
  const [orderNumber, setOrderNumber] = useState('');

  useEffect(() => {
    // Extract order number from URL parameters
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const orderId = searchParams.get('orderNumber');
    if (orderId) {
      setOrderNumber(orderId);
    }
  }, []);

  const orderDetailItems = queryData?.orderDetails?.orderDetailItems || {};

  const {
    billingInfo,
    shippingDetails,
    vatDutyDetails,
    summary,
    ctaGroup,
    products,
    packages,
    wssPaymentDetails,
    heading,
    status,
    currency,
    currencySymbol,
  } = orderDetailItems;

  const {
    pleaseTryAgain,
    processingText,
    successText,
  } = queryData?.textFor || {};

  return (
    <div className="order-details-content" data-testid="order-details-content">
      {wssPaymentDetails && wssPaymentDetails.paymentUpdateNeeded && (
        <WssPaymentAuthorizationSection
          orderNumber={orderNumber}
          wssPaymentDetails={wssPaymentDetails}
          onPaymentError={onPaymentError}
          onPaymentSuccess={onPaymentSuccess}
          currency={currency}
          currencySymbol={currencySymbol}
        />
      )}
      <WssOrderDetailsSection
        heading={heading}
        status={status}
        hasWssPaymentDetails={wssPaymentDetails && wssPaymentDetails.paymentUpdateNeeded}
      >
        <Row>
          { summary
          && (
          <Column md="4">
            <div className="order-total-summary" data-testid="order-total-summary">
              <OrderTotalSummary summary={summary} />
            </div>
          </Column>
          )}
          { ctaGroup && (
          <Column md="4">
            <div className="order-details-cta-group" data-testid="order-details-cta-group">
              <OrderDetailsCTAGroup
                ctaGroupButtons={{
                  ctaGroup,
                  number: orderNumber,
                  resendOrder: {
                    number: ctaGroup[0]?.value,
                    buttonText: ctaGroup[0]?.label,
                    processing: processingText,
                    error: pleaseTryAgain,
                    success: successText,
                  },
                }}
              />
            </div>
          </Column>
          )}
        </Row>
        <hr />
        <OrderItemsContainer
          orderProducts={products || []}
          packages={packages || []}
          text={queryData?.textFor}
          currency={currency}
          currencySymbol={currencySymbol}
        />
        <OrderSummary
          shippingDetails={shippingDetails}
          billingInfo={billingInfo}
          vatDutyDetails={vatDutyDetails}
        />
      </WssOrderDetailsSection>
    </div>
  );
}

OrderDetailsContent.propTypes = {
  ...orderDetailsDataProps,
  onPaymentError: PropTypes.func,
  onPaymentSuccess: PropTypes.func,
};
OrderDetailsContent.defaultProps = {
  ...orderDetailsDataDefaultProps,
  onPaymentError: undefined,
  onPaymentSuccess: undefined,
};
